import AES from '@ali/aes-tracker';
import getLastAction from './utils/getLastAction';
import genXpth from './utils/genXpath';
import requestIdleCallback from './utils/requestIdleCallback';
import { watchPageVisiblityChange } from './utils/visibilityChange';

(function () {
  if (!window.PerformanceLongTaskTiming) {
    return;
  }

  var observer = new PerformanceObserver(function (list) {
    list.getEntries().forEach(function (entry) {
      var e = getLastAction();
      requestIdleCallback(function () {
        AES.log('longtask', {
          // 开始时间
          startTime: entry.startTime,
          // 持续时间
          duration: entry.duration,
          // 最后操作的节点的CSS选择器
          xpath: e ? genXpth(e.path || e.target) : ''
        });
      });
    });
  });
  observer.observe({
    entryTypes: ["longtask"]
  });
  watchPageVisiblityChange(function (isVisible) {
    if (!isVisible) {
      observer.disconnect();
    } else {
      setTimeout(function () {
        observer.observe({
          entryTypes: ["longtask"]
        });
      }, 100);
    }
  });
})();


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ali_aes-tracker-plugin-longtask@1.0.1@@ali/aes-tracker-plugin-longtask/es/index.js
// module id = null
// module chunks = 